import React, {useContext, useEffect, useState} from 'react';
import './Calendar.css';
import {Navigate} from "react-big-calendar";
import {getISOWeek} from "date-fns";
import {Modal} from "../Modal.tsx";
import {APIContext, defineBackend} from "../Globals.tsx";
import SelectDateWeex from "../elements/SelectDateWeex";
import {sexes} from "../ToDos";
import SelectWeex from "../elements/SelectWeex";
import TextInputWeex from "../elements/TextInputWeex";
import StripeCheckout from "../StripeCheckout";

const weekday = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

export function getWeekRange(date = new Date()){
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  const monday = new Date(date);
  monday.setDate(date.getDate() + diff);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  const toISO = (d) => d.toLocaleDateString("de-DE");
  return {start: toISO(monday), end: toISO(sunday)};
}

function closerThan14Days(newInput){
  return new Date(newInput.startDate) < new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);
}

export default function WeexCalendar({date, setCurrentDate, setToolbar}){
  const [courses, setCourses] = useState([]);
  const [info, setInfo] = useState("");
  const [formData, setFormData] = useState({firstname: '', lastname: '', email: ''});
  const [newInput, setNewInput] = useState(false);
  const [backend, setBackend] = useState(null);
  const [paymentIntent, setPaymentIntent] = useState(null);
  const {fetchCalendarWeek, dropIn, createLeadAndDropin} = useContext(APIContext);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const backendParam = queryParams.get('weex');
    const date = queryParams.get('date');

    let backend_ = defineBackend(backendParam);
    setBackend(backend_);
    if(date){
      setToolbar(false);
      setCurrentDate(new Date(date));
    }
  }, []);

  useEffect(() => {
    const {start, end} = getWeekRange(date);
    if(backend){
      fetchCourses(start, end).then(setCourses);
    }
  }, [date, backend]);

  async function fetchCourses(startDate, endDate){
    return await fetchCalendarWeek(backend, startDate, endDate).then((ans) => {
      setInfo(ans?.info);
      return ans?.days?.flat() ?? [];
    });
  }

  async function anmelden(newInput){
    if(info === "dropin"){
      createLeadAndDropin(backend, {...formData}, newInput.type).then(e => setPaymentIntent(e));
    }
    else{
      dropIn(backend, {...formData, course: newInput}).then(setNewInput(false));
    }
  }

  const groupedCourses = courses.reduce((acc, c) => {
    acc[c.startDate] = acc[c.startDate] || [];
    acc[c.startDate].push(c);
    return acc;
  }, {});

  const renderParticipantStatusBar = (course) => {
    const percent = Math.min(100, (course.participants.length / course.participantsMax) * 100).toFixed(1);
    const color = course.participants.length >= course.participantsMax ? '#f44336' : '#4caf50';

    return (
      <div className="participant-bar-wrapper">
        <div className="participant-bar-bg">
          <div className="participant-bar-fill" style={{width: `${percent}%`, backgroundColor: color}}/>
        </div>
        <div className="participant-text">
          {course.participants.length}/{course.participantsMax}
        </div>
      </div>
    );
  };

  function handleChangeAddress(field, value){
    let address = formData.address;
    address = {...address, [field]: value};
    setFormData({...formData, address});
  }

  function renderInput(){
    if(paymentIntent){
      return <StripeCheckout course={newInput.id} intent={paymentIntent} onAbort={() => setNewInput(false)}/>;
    }
    return <Modal
      actionP={(() => anmelden(newInput))}
      actionS={() => setNewInput(false)}
      buttonS={"Abbrechen"}
      buttonP={info === "dropin" ? "Jetzt zahlen" : "Anfragen"}
      header={"Anmelden " + newInput.type + " am " + new Date(newInput.startDate)?.toLocaleDateString("de-DE")}
      valid={formData.lastname && formData.lastname && formData.email.match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) && (info !== "dropin" || (formData.birthday && formData.sex && formData?.address?.street && formData?.address?.zip && formData?.address?.city && formData?.address?.country))
        && (!newInput.type.toLocaleLowerCase().includes("intern") || formData.password === newInput.info) && formData.agb && (!closerThan14Days(newInput) || formData.ct14d)}>
      <br/>
      <TextInputWeex
        placeholder="Vorname"
        label={"Vorname"}
        required
        value={formData.firstname}
        onChange={(e) => setFormData({...formData, firstname: e.target.value})}
        light={true}
      />
      <TextInputWeex
        placeholder="Nachname"
        label={"Nachname"}
        required
        value={formData.lastname}
        onChange={(e) => setFormData({...formData, lastname: e.target.value})}
        light={true}
      />
      <TextInputWeex
        type="email"
        placeholder="E-Mail"
        label={"E-Mail"}
        required
        value={formData.email}
        onChange={(e) => setFormData({...formData, email: e.target.value})}
        light={true}
      />
      {info === "dropin" && <SelectDateWeex value={formData.birthday ?? {}}
                                            onChange={(e) => setFormData({...formData, birthday: e})}
                                            label={"Geburtstag"} light={true}/>}
      {info === "dropin" &&
        <SelectWeex options={sexes}
                    onChange={(e) => setFormData({...formData, sex: e.value})}
                    placeholder={"M/W/D"}
                    isMulti={false}
                    valueRaw={formData.sex || "D"}
                    isClearable={false}
                    label={"Geschlecht"}
                    light={true}
        />}
      {info === "dropin" &&
        <details className={"flex-column"} open={true}>
          <summary>Rechnungsadresse</summary>
          <TextInputWeex
            placeholder={"Straße"}
            label={"Straße"}
            value={formData.address?.street || ""}
            onChange={e => handleChangeAddress("street", e.target.value)}
            light={true}
          /><br/>
          <div className={"flex-row"}>
            <TextInputWeex
              placeholder={"PLZ"}
              label={"PLZ"}
              value={formData.address?.zip || ""}
              onChange={e => handleChangeAddress("zip", e.target.value)}
              light={true}
            />
            <TextInputWeex
              placeholder={"Ort"}
              label={"Ort"}
              value={formData.address?.city || ""}
              onChange={e => handleChangeAddress("city", e.target.value)}
              light={true}
            />
          </div>
          <br/>
          <TextInputWeex
            placeholder={"Land"}
            label={"Land"}
            value={formData.address?.country || ""}
            onChange={e => handleChangeAddress("country", e.target.value)}
            light={true}
          />
        </details>}
      {newInput.type.toLocaleLowerCase().includes("intern") &&
        <TextInputWeex
          placeholder={"Kennung"}
          label={"Kennung"}
          value={formData.password || ""}
          onChange={(e) => setFormData({...formData, password: e.target.value})}
          light={true}
        />}
      {info === "dropin" &&
        <div style={{maxWidth:400, textAlign: "left"}} onClick={() => setFormData({...formData, agb: !formData.agb})}>
        <input type={"checkbox"} checked={formData.agb}/>
          {" "}Ich habe die AGB und die Datenschutzerklärung gelesen und stimme ihnen zu.
        </div>}
      {info === "dropin" && closerThan14Days(newInput) &&
        <div style={{maxWidth:400, textAlign: "left"}} onClick={() => setFormData({...formData, ct14d: !formData.ct14d})}>
        <input type={"checkbox"} checked={formData.ct14d}/>
          {" "}Ich verlange ausdrücklich, dass der Kurs vor Ablauf der 14-tägigen Widerrufsfrist beginnt. Mir ist bekannt, dass ich dadurch mein Widerrufsrecht verliere.
        </div>}
    </Modal>;
  }

  return (
    <div className="calendar-wrapper">
      {newInput && renderInput()}
      <div id="calendar">
        {Object.keys(groupedCourses)
          .sort()
          .map((dateStr) => {
            const dateObj = new Date(dateStr);
            const month = dateObj.toLocaleString('de-DE', {month: 'short'});
            return (
              <div className="day" key={dateStr}>
                <div className="date-card">
                  <div className="weekday">{weekday[dateObj.getDay()]}</div>
                  <div className="daynumber">{dateObj.getDate() + '. ' + month}</div>
                </div>
                <div className="cards-container">
                  {groupedCourses[dateStr].map((course) => {
                    const isFull = course.participants.length >= course.participantsMax;
                    const signInAble =
                      new Date(new Date(course.startDate + 'T' + course.startTime).getTime() -
                        course.signInWindow * 60000) > new Date();

                    return (
                      <div className="card" style={{width: "100%", marginBottom: 10}}
                           key={course.id}>
                        <div className="card-border"/>
                        <div className="card-content">
                          <div className="row">
                            <strong>{course.type}</strong>
                            <div>{course.startTime} - {course.endTime} Uhr</div>
                          </div>
                          <div className="row">
                            <span className="info-text">Sign-in {course.signInWindow} Min vorher</span>
                            <span className="info-text">Sign-out {course.signOutWindow} Min vorher</span>
                          </div>
                          <div className="row">
                            {renderParticipantStatusBar(course)}
                            {info !== "no-email" && <button
                              className="primarybutton"
                              onClick={() => setNewInput(course)}
                              disabled={!signInAble || isFull}
                            >
                              {info === "dropin" ? "Anmelden" : "Anfragen"}
                            </button>}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

WeexCalendar.navigate = (date, action, {localizer}) => {
  switch(action){
    case Navigate.PREVIOUS:
      return localizer.add(date, -7, 'day');

    case Navigate.NEXT:
      return localizer.add(date, 7, 'day');

    default:
      return date;
  }
};

WeexCalendar.title = (date, {localizer}) => {
  return `${localizer.startOf(date, 'week').toLocaleDateString('de-DE')} - ${localizer.endOf(date, 'week').toLocaleDateString('de-DE')} KW ${getISOWeek(date)}`;
};